import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import Navbar from '../NavBar/Navbar';
import MapDashboard from '../myproporties/MapDashboard';
import FadeLoader from "react-spinners/FadeLoader";
import OwnerRegistration from './OwnerRegistration';
import { fetchUsersWithValidEmpId, deleteUserByEmail } from '../../Services/userService.js';
import { GetUserDetailsFromToken } from '../../Services/employeeService.jsx';
import OwnerDetailsComponent from './OwnerDetailsComponent.jsx';
import OwnerRegistartionCard from './OwnerRegistrationList.jsx';
import './OwnerRegistration.css';
import { fetchParkinglotDetailsbyentityid } from '../../Services/parkinglotService';
// import { UpdateOwnerVideoUrl } from '../../Services/userService.js';



const OwnerRegistationDashboard = (props) => {
    const location = useLocation();
    const ownerId = location.state?.ownerId || '';
    const [userDetails, setUserdetails] = useState([]);
    const [filter, setFilter] = useState([]);
    const [search, setSearch] = useState("");
    const [, setPopupVisible] = useState(false);
    const [open, setOpen] = useState(false);
    const [userData, setUserdata] = useState();
    const [isEdit, setEdit] = useState(false);
    const [defaultaddress, setDefaultaddress] = useState();
    const [loader, setLoader] = useState(false);
    const [selectedStatus] = useState('');
    const [, setSalespersonloggedin] = useState(true);
    const [registerOwner, setRegisterOwner] = useState(location.state?.showOwnerRegistration || false);
    const [fetchUsers, setFetchusers] = useState(false);
    const [selectedRowEmailID, setSelectedRow] = useState();
    const [selectedOwnerRow, setSelectedOnerDetails] = useState(null);
    const [OwnerDetails, setOwnerDetails] = useState(false);
    const [EmailIdOwner, setEmailId] = useState();
    const [entityIdOwner, setEntityIdowner] = useState();
    const [ownerb2cId, setOwnerb2cId] = useState();
    const [salespersonloggedin, setSalesperson] = useState();
    const [OwnerName, setOwnerName] = useState();
    const [mapVisibleChanges, setMapVisibleChanges] = useState(false);
    const [activeMenuId, setActiveMenuId] = useState(null);
    const [b2cuserID, setUserID] = useState();
    const [empId, setEmpId] = useState();
    const [unauthorizedAccess, setUnauthorizedAccess] = useState(false);
    const [activeTab, setActiveTab] = useState('registered'); // default tab: registered
    const navigate = useNavigate();
    const [parkingLotsMap, setParkingLotsMap] = useState({});
    const [deleteLoader, setDeleteLoader] = useState(false);
    const [deleteSource, setDeleteSource] = useState(null);

    const handleMapVisibleChanges = (value) => {
        setMapVisibleChanges(value);
    };

    const handleUserdetails = (val) => {
        setUserdetails(val);
    };

    const handleActiveMenuId = (val) => {
        setActiveMenuId(val);
    };

    const handleRegsiterOwner = (e, val, entityid, entityval, userid) => {
        if (e) { e.stopPropagation(); }
        setRegisterOwner(val);
        setEmailId(entityid);
        setEntityIdowner(entityval);
        setOwnerb2cId(userid);
        setSearch('');
    };

    const addOwner = (e) => {
        if (e) { e.stopPropagation(); }
        setRegisterOwner(true);
        setOwnerDetails(false);
    };

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const userData = await GetUserDetailsFromToken();
                setSalesperson(userData?.firstName);
                setEmpId(userData?.empId);
            } catch (error) {
                console.error("Error fetching user data:", error);
            }
        };
        fetchUserData();
    }, []);

    useEffect(() => {
        const fetchUserData = async () => {
            setLoader(true);
            try {
                const userData = await fetchUsersWithValidEmpId();
                if (ownerId) {
                    const selectedOwnerDetails = userData.find(
                        (item) => Number(item.entityRegistrationID) === Number(ownerId)
                    );
                    setSelectedOnerDetails(selectedOwnerDetails || null);
                    setOwnerDetails(true);
                }
                if (userData.userData !== null) {
                    setUserdetails(userData);
                } else {
                    setUserdetails([]);
                }
            } catch (error) {
                if (error.message.includes('Unauthorized')) {
                    console.error("Unauthorized access");
                    setUnauthorizedAccess(true);
                } else {
                    console.error("Error fetching user data:", error);
                }
            } finally {
                setLoader(false);
            }
        };
        fetchUserData();
    }, [fetchUsers, registerOwner, OwnerDetails, ownerId]);

    // Fetch parking lots for all owners and build a map keyed by entityRegistrationID
    useEffect(() => {
        const fetchAllParkingLots = async () => {
            if (!Array.isArray(userDetails) || userDetails.length === 0) return;
            try {
                const entries = await Promise.all(
                    userDetails.map(async (owner) => {
                        const entityId = owner.entityRegistrationID;
                        if (!entityId) return [entityId, []];
                        try {
                            const lots = await fetchParkinglotDetailsbyentityid(entityId);
                            return [entityId, Array.isArray(lots) ? lots : []];
                        } catch {
                            return [entityId, []];
                        }
                    })
                );
                setParkingLotsMap(Object.fromEntries(entries));
            } catch (error) {
                console.error("Error fetching parking lots for owners:", error);
            }
        };
        fetchAllParkingLots();
    }, [userDetails]);
    useEffect(() => {
        let result = userDetails;

console.log("result12345", result);

        // Filter by activeTab first
        if (activeTab === 'registered') {
            result = result.filter(item => item?.userId);
        } else if (activeTab === 'unregistered') {
            result = result.filter(item => !item?.userId);
        }

        // Apply search filter
        if (search) {
            const searchLower = search.toLowerCase();
           result = result.filter(item => {
                // Search inside parking lots fetched via fetchParkinglotDetailsbyentityid
                // nickName and parkingLotAddress (street address) live on each parking lot record
                const parkingLots = parkingLotsMap[item.entityRegistrationID] || [];
                const matchesParkingLot = parkingLots.some(lot =>
                    (lot.nickName && lot.nickName.toLowerCase().includes(searchLower)) ||
                    (lot.parkingLotAddress && lot.parkingLotAddress.toLowerCase().includes(searchLower))
                );

                return (
                    (item.entityName && item.entityName.toLowerCase().includes(searchLower)) ||
                    (item.emailId && item.emailId.toLowerCase().includes(searchLower)) ||
                    (item.mobileNumber && item.mobileNumber.toLowerCase().includes(searchLower)) ||                
                    (item.enityMailingAdderess && item.enityMailingAdderess.toLowerCase().includes(searchLower)) ||
                    (item.firstName && item.firstName.toLowerCase().includes(searchLower)) ||
                    (item.createdDate && item.createdDate.toLowerCase().includes(searchLower))||
                    matchesParkingLot
                );
            });
        }

        // Apply status filter if any
        if (selectedStatus.length > 0) {
            result = result.filter((item) => selectedStatus.includes(item.status));
        }

        setFilter(result);
    }, [userDetails, activeTab, search, selectedStatus]);

    // Counts
    const registeredOwnersCount = userDetails?.filter(item => item.userId).length;
    const unregisteredOwnersCount = userDetails?.filter(item => !item.userId).length;

    // Updated button handlers that only update the activeTab
    const handleRegisteredClick = () => {
        setLoader(true);
        setSearch('');
        setTimeout(() => {
            setActiveTab('registered');
            setLoader(false);
        }, 500);
    };

    const handleUnregisteredClick = () => {
        setLoader(true);
        setSearch('');
        setTimeout(() => {
            setActiveTab('unregistered');
            setLoader(false);
        }, 500);
    };

    const handleDelete = (e, val, source = 'ownerDashboard') => {
        if (e) { e.stopPropagation(); }
        setSelectedRow(val?.emailId);
        setOwnerName(val?.firstName);
        setDeleteSource(source);
        // setOwnerDetails(false);
        setOpen(true);
        if (val?.userId != null) {
            setUserID(val?.userId);
        }
    };
    const handleEdit = (e, val) => {
        if (e) { e.stopPropagation(); }
        setDefaultaddress(val?.enityMailingAdderess);
        setUserdata(val);
        setEdit(true);
        setSalespersonloggedin(true);
    };

    const handleConfirm = (name, EmailID, userid) => {
        if (name === "confirm") {
            setDeleteLoader(true);
            deleteUserByEmail(EmailID, userid)
                .then((result) => {
                    if (result.success) {
                        setFetchusers(fetchUsers => !fetchUsers);
                        setPopupVisible(false);
                        setOpen(false);
                        if (deleteSource === 'details') {
                            setOwnerDetails(false);
                        }
                    } else {
                        console.error(result.message);
                    }
                })
                .catch((error) => {
                    console.error('Error during deletion:', error);
                })
                .finally(() => {
                    setDeleteLoader(false);
                });
        }
        if (name === "cancel") {
            setOpen(false);
        }
    };

    const handleRowClick = (row) => {
        setSelectedOnerDetails(row);
        setOwnerDetails(true);
    };

    const handleSelectedowner = () => {
        setOwnerDetails(false);
        navigate('/OwnerRegistrationDashboard');
    };

    return (
        <div>
            {loader && (
                <div className="loader-overlay">
                    <FadeLoader />
                </div>
            )}
            {deleteLoader && (
                <div style={{
                    position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 99999
                }}>
                    <FadeLoader color="#36d7b7" />
                </div>
            )}

            {unauthorizedAccess ? (
                <div className="unauthorized-container">
                    <h2>Unauthorized Access</h2>
                    <p>You do not have permission to view this content.</p>
                </div>
            ) : (
                <>
                    <Navbar userData={userData} mapvisible={mapVisibleChanges} setMapvisible={setMapVisibleChanges} />
                    {registerOwner && !loader ? (
                        <OwnerRegistration
                            registerOwner={registerOwner}
                            handleUserdetails={handleUserdetails}
                            handleRegsiterOwner={handleRegsiterOwner}
                            empId={empId}
                            EmailIdOwner={EmailIdOwner}
                            entityIdOwner={entityIdOwner}
                            ownerb2cId={ownerb2cId}
                            setOwnerRegistrationChanges={setMapVisibleChanges}
                        />
                    ) : (
                        !isEdit ? (
                            OwnerDetails && !loader ? (
                                <OwnerDetailsComponent
                                    handleSelectedowner={handleSelectedowner}
                                    selectedRow={selectedOwnerRow}
                                    propertyOwner={OwnerDetails}
                                    handleEdit={handleEdit}
                                    handleDelete={handleDelete}
                                    handleRegsiterOwner={handleRegsiterOwner}
                                    RegsiterOwner={addOwner}
                                    mapVisibleChangesAlert={handleMapVisibleChanges}
                                    onConfirmDelete={(name, email, userId) => {
                                        handleConfirm(name, email, userId);
                                    }}
                                    setDeleteSource={setDeleteSource}
                                />
                            ) : (
                                !loader &&
                                <div>
                                    <div className='container-fluid p-0'>
                                        <div className="lotmanagement">
                                            <div className="row alignLeft">
                                                <div className="col-7">
                                                    <div className='viewHeader'>Manage Owners & Properties</div>
                                                </div>
                                            </div>
                                            <div className="row mb-2">
                                                <div className="col-12">
                                                    <div className="d-flex justify-content-between align-items-center flex-wrap">
                                                        <div className="tab-buttons-owner d-flex gap-3 mb-2 mb-md-0">
                                                            <button
                                                                className={`tab-button ${activeTab === 'registered' ? 'active' : ''}`}
                                                                onClick={handleRegisteredClick}
                                                            >
                                                                Total Registered Owners
                                                                <span className={`tab-count ${activeTab === 'registered' ? 'active-count' : ''}`}>
                                                                    {registeredOwnersCount}
                                                                </span>
                                                            </button>
                                                            <button
                                                                className={`tab-button ${activeTab === 'unregistered' ? 'active' : ''}`}
                                                                onClick={handleUnregisteredClick}
                                                            >
                                                                Total Unregistered Owners
                                                                <span className={`tab-count ${activeTab === 'unregistered' ? 'active-count' : ''}`}>
                                                                    {unregisteredOwnersCount}
                                                                </span>
                                                            </button>
                                                        </div>
                                                        <div className="col-3">
                                                            <input
                                                                type='text'
                                                                className="form-control"
                                                                placeholder='Search'
                                                                value={search}
                                                                onChange={(e) => setSearch(e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="col-2 a alignEnd">
                                                            <button
                                                                className="add-property-btn"
                                                                onClick={(e) => handleRegsiterOwner(e, true)}
                                                            >
                                                                Register Owner
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {
                                                userDetails?.length === 0 ? (
                                                    <div className="d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
                                                        <h5 style={{ color: "black" }}>No Records Found</h5>
                                                    </div>
                                                ) : (
                                                    Array.isArray(filter) && filter.length > 0 ? (
                                                        filter.map((property, index) => (
                                                            <div key={index} onClick={() => handleRowClick(property)}>
                                                                <OwnerRegistartionCard
                                                                    handleRegsiterOwner={handleRegsiterOwner}
                                                                    ownerName={property.firstName}
                                                                    entityName={property.entityName}
                                                                    email={property.emailId}
                                                                    property={property}
                                                                    entityId={property.entityRegistrationID}
                                                                    b2cidowner={property?.userId}
                                                                    activeMenuId={activeMenuId}
                                                                    onActiveMenuIdChange={handleActiveMenuId}
                                                                    mobilePhone={property.mobileNumber}
                                                                    entityAddress={property.enityMailingAdderess}
                                                                    handleEdit={(e) => handleEdit(e, property)}
                                                                    handleDelete={(e) => handleDelete(e, property, 'ownerDashboard')}
                                                                    isEmailPhoneVerified={property.isEmailPhoneVerified}
                                                                    isTempPassword={property.isTempPassword}
                                                                    tandC={property.tandC}

                                                                />
                                                            </div>
                                                        ))
                                                    ) : (
                                                        <div className="d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
                                                            <h5 style={{ color: "black" }}>No Records Found</h5>
                                                        </div>
                                                    )
                                                )
                                            }

                                        </div>
                                    </div>

                                    <Dialog
                                        classes={{ paper: 'custom-paper-class-delete' }}
                                        aria-labelledby="customized-dialog-title"
                                        dividers
                                        open={open}
                                        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <DialogTitle dividers sx={{ textAlign: 'start', color: "#000", fontSize: "24px", fontWeight: "700", padding: "5px 24px" }} id="customized-dialog-title">
                                            Are you Sure You Want to Delete This {OwnerName} Property?
                                        </DialogTitle>
                                        <DialogContent style={{ border: "none", padding: "5px 22px", color: "#000" }}>
                                            <Typography>
                                                <span>If you delete this owner, all parking lots associated to this owner will be deleted.</span>
                                            </Typography>
                                            <Typography gutterBottom>
                                                <span>This action is irreversible. Please confirm if you wish to proceed.</span>
                                            </Typography>
                                        </DialogContent>
                                        <DialogActions sx={{ justifyContent: 'right' }}>
                                            <Button className='custom-button-cancel' onClick={() => handleConfirm('cancel')}>Cancel</Button>
                                            <Button className='custom-button-delete' onClick={() => handleConfirm('confirm', selectedRowEmailID, b2cuserID)}>Delete</Button>
                                        </DialogActions>
                                    </Dialog>
                                </div>
                            )
                        ) : (
                            <MapDashboard
                                defaultaddress={defaultaddress}
                                userData={userData}
                                entityId={userData?.entityRegistrationID}
                                empId={empId}
                                verificationstatus={!(userData?.isEmailPhoneVerified || (userData?.isEmailVerified && userData?.isPhoneVerified))}
                                verifiedBy={salespersonloggedin}
                                mapVisibleChangesAlert={handleMapVisibleChanges}
                            />
                        )
                    )}
                </>
            )}
            {/* <UploadOwnerRecording
                open={videoModalOpen}
                onClose={handleCloseVideoModal}
                onSave={handleSaveVideo}
            /> */}
        </div>
    );
};

export default OwnerRegistationDashboard;
